import axios from "axios";
import { useNavigate } from "react-router-dom";
import DashNav from "../Dashboard/DashNav.js";
import * as React from "react";
import Stack from "@mui/material/Stack";
import Sidebar from "../Dashboard/Sidebar.js";
import Feed from "../Dashboard/Feed";
import { Box } from "@mui/system";
import {
  Button,
  Chip,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
  Skeleton,
  TextField,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import Paper from "@mui/material/Paper";
import { DataGrid, GridToolbar, GridToolbarQuickFilter } from "@mui/x-data-grid";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import { ToastContainer, toast } from "react-toastify";
import { PersonAdd, Security, Edit, Delete } from "@mui/icons-material";

const carBrandNames = require("./VehicleBrands.js");

// --- MODERN STYLED COMPONENTS ---

const RootContainer = styled(Box)({
  background: "#F8FAFC",
  minHeight: "100vh",
  display: "flex",
});

const ContentArea = styled(Box)(({ theme }) => ({
  flexGrow: 1,
  marginLeft: "18vw",
  padding: "40px",
  width: "calc(100% - 18vw)",
  transition: "all 0.3s ease",
  [theme.breakpoints.down("md")]: {
    marginLeft: 0,
    width: "100%",
    padding: "20px",
    paddingTop: "84px",
  },
}));

const GlassCard = styled(Paper)({
  padding: "24px",
  borderRadius: "16px",
  background: "#FFFFFF",
  border: "1px solid #E2E8F0",
  boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
});

const StyledDataGrid = styled(DataGrid)({
  border: "none",
  backgroundColor: "#FFFFFF",
  borderRadius: "16px",
  "& .MuiDataGrid-columnHeaders": {
    backgroundColor: "#F1F5F9",
    color: "#475569",
    fontWeight: 700,
    fontSize: "14px",
    borderBottom: "1px solid #E2E8F0",
  },
  "& .MuiDataGrid-cell": {
    borderBottom: "1px solid #F1F5F9",
    color: "#1E293B",
  },
  "& .MuiDataGrid-footerContainer": {
    borderTop: "1px solid #E2E8F0",
  },
  "& .wrap-text": {
    whiteSpace: "normal",
  },
});

const ModalBox = styled(Box)(({ theme }) => ({
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "500px",
  maxHeight: "90vh",
  overflowY: "auto",
  backgroundColor: "#FFFFFF",
  borderRadius: "20px",
  boxShadow: "0 20px 25px -5px rgba(0, 0, 0, 0.1)",
  outline: "none",
  [theme.breakpoints.down("sm")]: {
    width: "95%",
  },
}));


function QuickSearchToolbar() {
  return (
    <Box
      sx={{
        p: 0.5,
        pb: 0,
      }}
    >
      <GridToolbarQuickFilter
        quickFilterParser={(searchInput) =>
          searchInput
            .split(',')
            .map((value) => value.trim())
            .filter((value) => value !== '')
        }
      />
    </Box>
  );
}
const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "white",
  border: "2px solid ",
  boxShadow: 24,
  p: 4,
};



function Users() {
  return (
    <RootContainer>
      <Sidebar />
      <UsersTable />
    </RootContainer>
  );
}


// function CustomLoadingOverlay() {
//   return (
//     <GridOverlay>
//       {/* <Skeleton variant="rect" width="100%" height="100%" /> */}
//     </GridOverlay>
//   );
// }

const UsersTable = () => {

    

  const renderCell = (params) => {
    const { field, value } = params;
    if (isLoading) {
      return <Skeleton variant="rec" width={50} height={20} />;
    } else {
      return value;
    }
  };
  // Datagrid Columns 
    const columns = [
        {
          field: "col0",
          headerName: "Actions",
          width: 220,
          sortable: false,
          filterable: false,
          renderCell: (cellValues) => {
            return (

              <Stack direction="row" spacing={1}>
                <Button
                  variant="outlined"
                  size="small"
                  startIcon={<Edit />}
                  onClick={(event) => {
                    handleEdit(event, cellValues);
                  }}
                  sx={{
                    borderRadius: "8px",
                    textTransform: "none",
                    borderColor: "#3B82F6",
                    color: "#3B82F6",
                    "&:hover": { borderColor: "#2563EB", bgcolor: "#eff6ff" }
                  }}
                >
                  Edit
                </Button>
                <Button
                  variant="outlined"
                  size="small"
                  color="error"
                  startIcon={<Delete />}
                  onClick={(event) => {
                    handleDelete(event, cellValues);
                  }}
                  sx={{
                    borderRadius: "8px",
                    textTransform: "none",
                    "&:hover": { bgcolor: "#fef2f2" }
                  }}
                >
                  Delete
                </Button>
              </Stack>
            );

          },
        },
        // { field: "id", sortable: false, headerName: "id", width: 300,          sortable: false,
        // filterable: false, },
        {
          field: "username",
          sortable: false,
          headerName: "Username",
          width: 150,
        },
        {
          field: "role",
          sortable: false,
          headerName: "Role",
          width: 300,
          valueFormatter: (params) => {
            const valueFormatted = params.value==="af7c1fe6-d669-414e-b066-e9733f0de7a8"?"Admin":"Leads Manager";
            return `${valueFormatted}`;
          },
        },
        {
            field: "fullname",
            sortable: false,
            headerName: "Fullname",
            width: 210,
          },
          {
            field: "email",
            sortable: false,
            headerName: "Email",
            width: 210,
          },
          {
            field: "profileImg",
            sortable: false,
            headerName: "Profile Image",
            width: 270,
          },
          
        { field: "createdAt", sortable: false, headerName: "CreatedAt", width: 210,
        valueFormatter: (params) => {
          const valueFormatted = new Date(params.value).toDateString();
          return `${valueFormatted}`;
        }, },
        { field: "updatedAt", sortable: false, headerName: "UpdatedAt", width: 210 ,valueFormatter: (params) => {
          const valueFormatted = new Date(params.value).toDateString();
          return `${valueFormatted}`;
        },},
      ];
      




  const [selectedImage, setSelectedImage] = React.useState(null);
const [base64Image, setBase64Image] = React.useState(null)
  const [existingUsers, setExistingUsers] = React.useState([]);
  //isUpdating State is used for checking if the modal open is for updating or adding a new one hence changing the button name 
  const [IsUpdating, setIsUpdating] = React.useState(false)
  const [isLoading, setisLoading] = React.useState(false)
  const [newUser, setNewUser] = React.useState({
    username: "",
    password: "",
    role:"",
    fullname:"",
    email:"",
    profileImg:""
  });
  const [userRoleName, setUserRoleName] = React.useState([]);
  const [open, setOpen] = React.useState(false);
  const [openPwdUpdate, setOpenPwdUpdate] = React.useState(false);
  const [openDelete, setOpenDelete] = React.useState(false);
  const [confirmDelete, setConfirmDelete] = React.useState(false);
  const handleOpenDelete = () => setOpenDelete(true);
  const handleCloseDelete = () => setOpenDelete(false);
const [forgetPass, setforgetPass] = React.useState({
  username:"",
  password:""
})







  const handleOpen = () => {
    setNewUser([])
    setOpen(true)
  };
  const handleClose = () => {
    setOpen(false);
    setIsUpdating(false)
  };

const handleForgetPwdOpen = (evnt) => {
  setforgetPass([])
    setOpenPwdUpdate(true)
}

const handlePwdUpdateClose =() =>{
  setOpenPwdUpdate(false)

}

function handlePwdChange(evt) {
  const value = evt.target.value;
  setforgetPass({
    ...forgetPass,
    [evt.target.name]: value,
  });
}

const  updatePasswordFunc= async () => {
  const token = localStorage.getItem("accessToken");
  const config = {
    headers: {
      auth: token,
    },
  };
  await axios
    .put("/user-pwd-update", forgetPass, config)
    .then((response) => {

      toast.success("Password Updated Successfully!");
      setOpenPwdUpdate(false)
      setforgetPass([])
    })
    .catch((err) => {
      console.log(err);
      if (err.response.data.error == "User Does Not Exists") {
        toast.error("User Does Not Exists");
      } else {
        toast.error("Password Cannot Be Updated");
      }
    }); 
}


  const handleBrandChange = (event) => {
    const {
      target: { value },
    } = event;
    setUserRoleName(
      // On autofill we get a stringified value.
      typeof value === "string" ? value.split(",") : value
    );
    handleChange(event);
  };


  function handleChange(evt) {
    const value = evt.target.value;
    setNewUser({
      ...newUser,
      [evt.target.name]: value,
    });
  }

  function handleEdit(Event,Value){

    setOpen(true)
    setNewUser({
        username:Value.row.username,
        role:Value.row.role,
        fullname:Value.row.fullname,
        email:Value.row.email,
        profileImg:Value.row.profileImg,
    })
    setIsUpdating(true)
  }

     async function handleDelete(Event,Value){

        if (window.confirm("You surely want to delete this User?")) {
          await deleteUser(Value.row.username) 
        }      // await deleteUser(Value.row.uid) 
        else{
          await getAllUsers()
        }
     }


   const getAllUsers = async () => {
            setisLoading(true)
            const token = localStorage.getItem("accessToken");
            const config = {
              headers: {
                auth: token,
              },
            };
             axios
              .get("/users", config)
              .then((response) => {
                  setExistingUsers(response.data.data);
                setisLoading(false)
              });
  };
  React.useEffect(() => {
    getAllUsers();
  }, []);

  const addNewUser = async () => {
    const token = localStorage.getItem("accessToken");
    const config = {
      headers: {
        auth: token,
      },
    };
    await axios
      .post("/user-register", newUser, config)
      .then((response) => {

        toast.success("User Registered Successfully!");
        setOpen(false)
        setUserRoleName([])
        getAllUsers()
      })
      .catch((err) => {
        console.log(err);
        if (err.response.data.error == "User Already Exists") {
          toast.error("User Already Exists");
        } else {
          toast.error("User Cannot Be Added");
        }
      });
  };
  const updateUser = async () => {
    const token = localStorage.getItem("accessToken");
    const config = {
      headers: {
        auth: token,
      },
    };
    await axios
      .put("/user-update", newUser, config)
      .then((response) => {
        toast.success("User Updated Successfully!");
        setOpen(false)
        setUserRoleName([])
        getAllUsers()
      })
      .catch((err) => {
        console.log(err);
        if (err.response.data.error == "User Already Exists") {
          toast.error("User Already Exists");
        } else {
          toast.error("User Cannot Be Updated");
        }
      }); 
  }

  const deleteUser = async (username) => {
    const token = localStorage.getItem("accessToken");
    const config = {
      headers: {
        auth: token,
      },
    };
    await axios
      .delete(`/user-delete/${username}`,  config)
      .then((response) => {
        toast.success("User Deleted Successfully!");
        setOpen(false)
        setUserRoleName([])
        getAllUsers()
      })
      .catch((err) => {
        console.log(err);
        if (err.response.data.error == "User Already Exists") {
          toast.error("User Already Exists");
        } else {
          toast.error("User Cannot Be Deleted");
        }
      }); 
  }

  return (
    <ContentArea>
      {/* HEADER SECTION */}
      <Stack 
        direction={{ xs: "column", md: "row" }} 
        justifyContent="space-between" 
        alignItems={{ xs: "flex-start", md: "center" }} 
        spacing={3}
        sx={{ mb: 4 }}
      >
        <Box>
          <Typography
            variant="h3"
            sx={{
              fontWeight: 800,
              color: "#1E293B",
              fontFamily: "Kamerik",
              letterSpacing: "-1.5px",
              fontSize: { xs: "2rem", md: "3rem" }
            }}
          >
            Manage Users
          </Typography>
          <Typography variant="body2" sx={{ color: "#64748B", fontWeight: 500 }}>
            Administer user accounts, roles, and access permissions
          </Typography>
        </Box>

        <Stack direction={{ xs: "column", sm: "row" }} spacing={2} width={{ xs: "100%", sm: "auto" }}>
          <Button
            variant="contained"
            color="error"
            startIcon={<Security />}
            onClick={handleForgetPwdOpen}
            sx={{
              borderRadius: "12px",
              px: 3,
              fontWeight: 700,
              height: "48px",
              whiteSpace: "nowrap"
            }}
          >
            Reset Password
          </Button>
          <Button
            variant="contained"
            startIcon={<PersonAdd />}
            onClick={handleOpen}
            sx={{
              borderRadius: "12px",
              px: 3,
              bgcolor: "#1E293B",
              fontWeight: 700,
              height: "48px",
              "&:hover": { bgcolor: "#0F172A" },
            }}
          >
            Add User
          </Button>
        </Stack>
      </Stack>

      <GlassCard elevation={0}>
        <Box sx={{ height: "70vh", width: "100%" }}>
          <StyledDataGrid
            rows={existingUsers}
            columns={columns}
            pageSize={50}
            disableSelectionOnClick
            loading={isLoading}
            components={{
              Toolbar: GridToolbar,
            }}
            componentsProps={{
              toolbar: {
                showQuickFilter: true,
                quickFilterProps: { debounceMs: 500 }
              },
            }}
            rowsPerPageOptions={[10, 25, 50, 100]}
            sx={{
              "& .MuiDataGrid-toolbarContainer": {
                padding: "16px",
                gap: "12px",
                borderBottom: "1px solid #E2E8F0",
                "& .MuiButton-root": {
                  color: "#64748B",
                  fontWeight: 700,
                  "&:hover": {
                    color: "#1E293B",
                  },
                },
              },
            }}
          />
        </Box>
      </GlassCard>
      <Modal
        open={open}
        onClose={handleClose}
      >
        <ModalBox>
          <Box
            sx={{
              p: 3,
              background: "linear-gradient(135deg, #1E293B 0%, #0F172A 100%)",
              color: "#fff",
              borderTopLeftRadius: "20px",
              borderTopRightRadius: "20px",
            }}
          >
            <Typography variant="h6" sx={{ fontWeight: 800, display: "flex", alignItems: "center", gap: 1 }}>
              <PersonAdd /> {IsUpdating ? "Update User" : "Add New User"}
            </Typography>
          </Box>
          
          <Box sx={{ p: 4 }}>
            <Stack spacing={3}>
              <TextField
                label="Username"
                variant="outlined"
                fullWidth
                name="username"
                onChange={handleChange}
                value={newUser.username || ""}
                disabled={IsUpdating}
                sx={{ "& .MuiOutlinedInput-root": { borderRadius: "12px" } }}
              />

              {!IsUpdating && (
                <TextField
                  label="Password"
                  type="password"
                  variant="outlined"
                  fullWidth
                  name="password"
                  onChange={handleChange}
                  sx={{ "& .MuiOutlinedInput-root": { borderRadius: "12px" } }}
                />
              )}

              {!IsUpdating && (
                <FormControl fullWidth>
                  <InputLabel>User Role</InputLabel>
                  <Select
                    value={newUser.role || ""}
                    onChange={handleBrandChange}
                    name="role"
                    label="User Role"
                    sx={{ borderRadius: "12px" }}
                  >
                    <MenuItem value={'af7c1fe6-d669-414e-b066-e9733f0de7a8'}>Admin</MenuItem>
                    <MenuItem value={'bg2f2ty7-as82-jhs2-3h43-h5h324ou42u9'}>Leads Manager</MenuItem>
                  </Select>
                </FormControl>
              )}

              <TextField
                label="Full Name"
                variant="outlined"
                fullWidth
                name="fullname"
                onChange={handleChange}
                value={newUser.fullname || ""}
                sx={{ "& .MuiOutlinedInput-root": { borderRadius: "12px" } }}
              />
              <TextField
                label="Email"
                variant="outlined"
                fullWidth
                name="email"
                onChange={handleChange}
                value={newUser.email || ""}
                sx={{ "& .MuiOutlinedInput-root": { borderRadius: "12px" } }}
              />
              <TextField
                label="Profile Image URL"
                variant="outlined"
                fullWidth
                name="profileImg"
                onChange={handleChange}
                value={newUser.profileImg || ""}
                sx={{ "& .MuiOutlinedInput-root": { borderRadius: "12px" } }}
              />

              <Button
                variant="contained"
                fullWidth
                size="large"
                onClick={IsUpdating ? updateUser : addNewUser}
                sx={{
                  mt: 2,
                  height: "56px",
                  borderRadius: "12px",
                  bgcolor: "#3B82F6",
                  fontSize: "1rem",
                  fontWeight: 700,
                  "&:hover": { bgcolor: "#2563EB" },
                }}
              >
                {IsUpdating ? "Update User" : "Add User"}
              </Button>
            </Stack>
          </Box>
        </ModalBox>
      </Modal>



      <Modal
        open={openPwdUpdate}
        onClose={handlePwdUpdateClose}
      >
        <ModalBox>
          <Box
            sx={{
              p: 3,
              background: "linear-gradient(135deg, #1E293B 0%, #0F172A 100%)",
              color: "#fff",
              borderTopLeftRadius: "20px",
              borderTopRightRadius: "20px",
            }}
          >
            <Typography variant="h6" sx={{ fontWeight: 800, display: "flex", alignItems: "center", gap: 1 }}>
              <Security /> Update Password
            </Typography>
          </Box>

          <Box sx={{ p: 4 }}>
            <Stack spacing={3}>
              <TextField
                label="Username"
                variant="outlined"
                fullWidth
                name="username"
                onChange={handlePwdChange}
                value={forgetPass.username || ""}
                sx={{ "& .MuiOutlinedInput-root": { borderRadius: "12px" } }}
              />

              <TextField
                label="New Password"
                type="password"
                variant="outlined"
                fullWidth
                name="password"
                onChange={handlePwdChange}
                value={forgetPass.password || ""}
                sx={{ "& .MuiOutlinedInput-root": { borderRadius: "12px" } }}
              />

              <Button
                variant="contained"
                fullWidth
                size="large"
                onClick={updatePasswordFunc}
                sx={{
                  mt: 2,
                  height: "56px",
                  borderRadius: "12px",
                  bgcolor: "#EF4444",
                  fontSize: "1rem",
                  fontWeight: 700,
                  "&:hover": { bgcolor: "#DC2626" },
                }}
              >
                Reset Password
              </Button>
            </Stack>
          </Box>
        </ModalBox>
      </Modal>



      <ToastContainer position="bottom-right" />
    </ContentArea>
  );
};
export default Users;
